import { useEffect } from 'react';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import HotDramas from './components/HotDramas';
import LatestDramas from './components/LatestDramas';
import DramaCard from '@/components/base/DramaCard';
import { dramas } from '@/mocks/dramas';

function setMetaTag(name: string, content: string, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export default function Home() {
  useEffect(() => {
    document.title = '香蕉影视 - 电视剧全集免费高清在线追剧，最新热播电视剧大全观看';
    setMetaTag('description', '香蕉影视提供电视剧全集免费高清在线追剧，最新热播电视剧大全观看，不缓冲流畅秒开不卡顿，全集免费看，追剧必备。香蕉影视,电视剧全集,免费追剧,高清在线,热播剧,不缓冲,秒开,全集免费看,最新电视剧,在线观看');
    setMetaTag('keywords', '香蕉影视,电视剧全集,免费追剧,高清在线,热播剧,在线观看');
    setMetaTag('og:title', '香蕉影视 - 电视剧全集免费高清在线追剧，最新热播电视剧大全观看', true);
    setMetaTag('og:description', '香蕉影视提供电视剧全集免费高清在线追剧，最新热播电视剧大全观看，不缓冲流畅秒开不卡顿，全集免费看，追剧必备。', true);
    setMetaTag('og:url', 'https://banana-tv.com/', true);

    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.setAttribute('href', 'https://banana-tv.com/');
    }
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '香蕉影视',
            url: 'https://banana-tv.com/',
            description: '香蕉影视提供电视剧全集免费高清在线追剧，最新热播电视剧大全观看，不缓冲流畅秒开不卡顿，全集免费看，追剧必备。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://banana-tv.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '香蕉影视',
            url: 'https://banana-tv.com/',
            description: '香蕉影视 - 电视剧全集免费高清在线追剧平台',
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://banana-tv.com/' },
            ],
          }),
        }}
      />

      <HeroBanner />
      <CategoryNav />
      <HotDramas dramas={dramas} />
      <LatestDramas dramas={dramas} />

      <section className="py-10 md:py-14">
        <div className="mx-auto max-w-[1400px] px-4 md:px-6">
          <div className="mb-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              全部剧集
            </h2>
            <p className="text-sm text-foreground-500 mt-1">海量好剧，随心观看</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-5">
            {dramas.map((drama) => (
              <DramaCard key={drama.id} drama={drama} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 bg-background-100">
        <div className="mx-auto max-w-[1400px] px-4 md:px-6">
          <div className="mb-6">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              为什么选择香蕉影视？
            </h2>
            <p className="text-sm text-foreground-500 mt-1">千万用户的选择，追剧更轻松</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {[
              { icon: 'ri-flashlight-line', title: '极速播放', desc: '不缓冲流畅秒开不卡顿，追剧体验丝滑顺畅' },
              { icon: 'ri-hd-line', title: '高清画质', desc: '全高清画质在线观看，细节清晰呈现' },
              { icon: 'ri-shield-check-line', title: '全集免费', desc: '所有剧集免费看，无需会员无需付费' },
              { icon: 'ri-smartphone-line', title: '多端同步', desc: '电脑手机平板全兼容，随时随地追剧' },
            ].map((item, idx) => (
              <div key={idx} className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-3">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <h4 className="font-heading text-base font-bold text-foreground-900 mb-1.5">{item.title}</h4>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}